/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Section_TimelineInputs */

const en_options_editor_section_timeline = /** @type {(inputs: Options_Editor_Section_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeline`)
};

const fr_options_editor_section_timeline = /** @type {(inputs: Options_Editor_Section_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeline`)
};

const de_options_editor_section_timeline = /** @type {(inputs: Options_Editor_Section_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitleiste`)
};

const it_options_editor_section_timeline = /** @type {(inputs: Options_Editor_Section_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronologia`)
};

const ru_options_editor_section_timeline = /** @type {(inputs: Options_Editor_Section_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хронология`)
};

const es_options_editor_section_timeline = /** @type {(inputs: Options_Editor_Section_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronología`)
};

const zh_cn2_options_editor_section_timeline = /** @type {(inputs: Options_Editor_Section_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间线`)
};

const ja_options_editor_section_timeline = /** @type {(inputs: Options_Editor_Section_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムライン`)
};

const hi_options_editor_section_timeline = /** @type {(inputs: Options_Editor_Section_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय`)
};

const pt_pt2_options_editor_section_timeline = /** @type {(inputs: Options_Editor_Section_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linha do tempo`)
};

/**
* | output |
* | --- |
* | "Timeline" |
*
* @param {Options_Editor_Section_TimelineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_section_timeline = /** @type {((inputs?: Options_Editor_Section_TimelineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Section_TimelineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_section_timeline(inputs)
	if (locale === "de") return de_options_editor_section_timeline(inputs)
	if (locale === "it") return it_options_editor_section_timeline(inputs)
	if (locale === "ru") return ru_options_editor_section_timeline(inputs)
	if (locale === "es") return es_options_editor_section_timeline(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_section_timeline(inputs)
	if (locale === "ja") return ja_options_editor_section_timeline(inputs)
	if (locale === "hi") return hi_options_editor_section_timeline(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_section_timeline(inputs)
	return en_options_editor_section_timeline(inputs)
});